// "200 characters read, minimum 1,000 × 1 page" from the figures a scan billed at its
// per-page minimum carries (a ledger entry or a refusal).
export function scanMinimumFormula(t, figures, language) {
  return t('common:scanMinimumFormula', {
    read: figures.scan_chars_read.toLocaleString(language),
    min: figures.scan_min_chars_per_page.toLocaleString(language),
    count: figures.scan_pages,
  });
}
